// extracted by mini-css-extract-plugin
export default {"header":"InfoBlock_header__5kLPn","title":"InfoBlock_title__Eoi9v"};